import React from 'react'
import { Box, Typography } from '@mui/material'
import { TooltipSeeker } from '@ui-seeker/core'

import { isMainRow } from 'Pages/AnalyzersV2/@components/Table/@utils'


export default function avgGapColumn(mainName) {
	return {
		name: '__avgGap',
		label: 'Avg gap',
		render: (_, row) => <AvgGapCell row={row} mainName={mainName}/>,
	}
}

function AvgGapCell({ row, mainName }) {
	// Same name the website column prints: `name` still holds the raw alias.
	const rowName = row?.nameFilter || row?.name

	// The main row has no gap against itself, so it carries its average price —
	// the baseline every other row in this column is measured against.
	if (isMainRow(row)) {
		const avgPrice = row?.avgPrice

		return <TooltipSeeker title={avgPrice == null ? '' : `${rowName} average price across the period`}>
			<Box sx={{ textAlign: 'center', width: 90 }}>
				<Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
					{avgPrice == null ? 'N/A' : avgPrice.toFixed(2)}
				</Typography>
			</Box>
		</TooltipSeeker>
	}

	const avgGap = row?.avgGap

	if (avgGap == null) {
		return <Box sx={{ textAlign: 'center', width: 90 }}>
			<Typography variant="caption" sx={{ color: 'text.disabled' }}>N/A</Typography>
		</Box>
	}

	const isCheaper = avgGap >= 0
	const tooltip = `${mainName || 'Main'} is on average ${Math.abs(avgGap).toFixed(1)}% ${isCheaper ? 'cheaper' : 'more expensive'} than ${rowName}`

	return <TooltipSeeker title={tooltip}>
		<Box sx={{ textAlign: 'center', width: 90 }}>
			<Typography
				variant="subtitle2"
				sx={{ fontWeight: 'bold', color: isCheaper ? 'success.dark' : 'error.main' }}>
				{isCheaper ? '+' : '−'}{Math.abs(avgGap).toFixed(1)}%
			</Typography>
		</Box>
	</TooltipSeeker>
}
